export default "/_next/static/images/texture-3-d017ff4514215d6e7849aa9ede90dfbe.png";